export const SET_ALL = 'SET_ALL';
export const UPDATE_OFFER_DATA_BY_ID = 'UPDATE_OFFER_DATA_BY_ID';
export const UPDATE_BID_DATA_BY_ID = 'UPDATE_BID_DATA_BY_ID';
export const ADD_OFFER_TO_LIST = 'ADD_OFFER_TO_LIST';
export const ADD_MESSAGE = 'ADD_MESSAGE';
